import {
  Coinbase,
  coinbaseId,
  Exodus,
  exodusId,
  MetaMask,
  metaMaskId,
  Okx,
  okxId,
  Rainbow,
  rainbowId,
  WalletConnect,
  wcId,
} from '../adapters';

export const ADAPTERS = {
  [metaMaskId]: MetaMask,
  [okxId]: Okx,
  [coinbaseId]: Coinbase,
  [exodusId]: Exodus,
  [rainbowId]: Rainbow,
  [wcId]: WalletConnect,
} as const;
